/**
 * Email addresses are case-insensitive in practice, but the API matches them
 * verbatim — signing in as "Foo@Bar.com" fails against a "foo@bar.com" record.
 * Auth payloads normalise the address through here on the way out; what the
 * user typed is left alone in the field itself.
 */
export const toLowerCaseEmail = (email) =>
  typeof email === "string" ? email.toLowerCase() : email;

export default toLowerCaseEmail;
